/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudCheckIcon16Solid = forwardRef('NetCloudCheckIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.037 5.187a4.25 4.25 0 0 1 8.088-1.185L11.25 4a4.5 4.5 0 1 1 0 9h-7a4 4 0 0 1-1.213-7.813Zm8.306 2.219a1 1 0 1 0-1.416-1.413L7.004 8.922 5.886 7.8A1 1 0 1 0 4.47 9.214l1.296 1.298a1.75 1.75 0 0 0 2.477 0l3.1-3.106Z" })));
});
